<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}

body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
fieldset,
legend,
input,
button,
textarea,
p,
blockquote,
th,
td {
  margin: 0;
  padding: 0;
}

body {
  background: #fff;
  /*overflow: hidden;*/
  color: #555;
  font-size: 14px;
  font-family: Hiragino Sans GB, Microsoft Yahei UI, Microsoft Yahei,
    "\5FAE\8F6F\96C5\9ED1", Segoe UI, Tahoma, "\5B8B\4F53 b8b\4F53", SimSun,
    sans-serif;
}

td,
th,
caption {
  font-size: 14px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: normal;
  font-size: 100%;
}

address,
caption,
cite,
code,
dfn,
em,
strong,
th,
var {
  font-style: normal;
  font-weight: normal;
}

a {
  color: #555;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

img {
  border: none;
  display: inline-block;
}

ol,
ul,
li {
  list-style: none;
}

input,
textarea,
select,
button {
  font: 14px Verdana, Helvetica, Arial, sans-serif;
}

table {
  border-collapse: collapse;
}

.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}
.el-table__body tr.current-row > td {
  background: #c1d9f3;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background: #c1d9f3;
}
.el-table--striped .el-table__body tr.el-table__row--striped.current-row td {
  background: #c1d9f3;
}

/*#B0B7C2*/
.el-table--border,
.el-table--group {
  border: 1px solid #b0b7c2 !important;
}
.el-table td,
.el-table th.is-leaf {
  border-bottom: 1px solid #b0b7c2 !important;
}
.el-table--border td,
.el-table--border th,
.el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
  border-right: 1px solid #b0b7c2 !important;
}
.el-table--border th,
.el-table__fixed-right-patch {
  border-bottom: 1px solid #b0b7c2 !important;
}
.ExerciseAnalysis .questions .questionsRight .questionAnalysis table tr td,
.AnalysisContainer #rightBox .analysisTable table tr td {
  border: 1px solid #b0b7c2 !important;
}
.el-input .el-input__inner {
  border-bottom: 1px solid #b0b7c2 !important;
}
.el-input__inner,
.el-textarea__inner {
  border: 1px solid #b0b7c2 !important;
}

.curriculum .table {
  border: 1px solid #b0b7c2 !important;
}

.ExerciseAnalysis .questionsRight > .el-table th.gutter {
  /*display: block!important;*/
  /*width: 15px !important;*/
  /*height:59px!important;*/
}
.ExerciseAnalysis .questionsRight > .el-table th:last-child {
  /*display: block;*/
  /*background: #000;*/
  /*width: 15px;*/
  /*height: 50px;*/
}

.ExerciseAnalysis .questions .questionsLeft .questionList {
  border: 1px solid #b0b7c2 !important;
}

font[size="7"] {
  font-size: 26pt;
}
font[size="6"] {
  font-size: 22pt;
}
font[size="5"] {
  font-size: 18pt;
}
font[size="4"] {
  font-size: 16pt;
}
font[size="3"] {
  font-size: 14pt;
}
font[size="2"] {
  font-size: 12pt;
}
font[size="1"] {
  font-size: 10.5pt;
}

.el-radio input[aria-hidden="true"] {
  display: none !important;
}

.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue